import { useEffect } from 'react';
import { useStore } from '@betgames/bg-state-manager';
import { GameId } from '@bg-shared/enums/GameId';
import { ILastResultModel } from '@bg-shared/business/LastResults/interfaces';
import { IGameItem } from '@bg-shared/interfaces/IGameItem';
import { lastResultsEntity } from '../LastResults.entity';

export const useLastResultsList = <T = IGameItem[]>(
    gameId: GameId,
    withoutTimeout = false,
): ILastResultModel<T>[] => {
    const results = useStore(lastResultsEntity.store(gameId));

    useEffect(() => {
        let unsubscribe: () => void;

        lastResultsEntity.initGameResults(gameId).then(() => {
            unsubscribe = lastResultsEntity.subscribeForUpdates(gameId, withoutTimeout);
        });

        return () => {
            unsubscribe?.();
        };
    }, []);

    return results as ILastResultModel<T>[];
};
